import { Space } from "antd";
import React from "react";
import { StyledButton } from "../styledComponent/styledElements";
import { CiEdit } from "react-icons/ci";
import { MdOutlineDelete } from "react-icons/md";
import { FaUser, FaUserSlash } from "react-icons/fa";

function TableActions({
  showEdit,
  showDelete,
  showUserDisable,
  showUserEnable,
  userActive = true,
  onClickEdit = () => {
    console.log("Edit Clicked");
  },
  onClickDelete = () => {
    console.log("Delete Clicked");
  },
  onClickDisable = () => {
    console.log("Disable Clicked");
  },
  onClickEnable = () => {
    console.log("Enable Clicked");
  },
}) {
  return (
    <Space size="small">
      {showEdit && (
        <StyledButton
          icon={<CiEdit />}
          background="#ededed"
          color="Black"
          border="White"
          height={32}
          onClick={onClickEdit}
        />
      )}
      {showDelete && (
        <StyledButton
          icon={<MdOutlineDelete />}
          danger
          background="#ededed"
          color="Black"
          border="White"
          height={32}
          onClick={onClickDelete}
        />
      )}
      {userActive
        ? showUserDisable && (
            <StyledButton
              icon={<FaUserSlash />}
              danger
              background="#ededed"
              color="Black"
              border="White"
              height={32}
              onClick={onClickDisable}
            />
          )
        : showUserEnable && (
            <StyledButton
              icon={<FaUser />}
              background="#ededed"
              color="green"
              border="White"
              height={32}
              onClick={onClickEnable}
            />
          )}
    </Space>
  );
}

export default TableActions;
